import { translatePlaneLabel } from '../../../../helpers/i18n/planeLabelI18n';
import { Plane, PlaneConfig } from '../types/planes.types';

// This function correctly accepts the theme as an argument
export const buildPlane = (config: PlaneConfig, globalState: any, theme: 'light' | 'dark'): Plane => {
  const planData = globalState?.planes?.[config.tag];

  // This is the key line: it chooses the image based on the passed theme
  const defaultImageForTheme = theme === 'dark' ? config.darkImage : config.defaultImage;

  return {
    label: translatePlaneLabel(config.tag, config.label),
    imgPlane: planData?.predictionHistory?.[0]?.imagePredictedPlane ?? defaultImageForTheme,
    tag: config.tag,
    quality_score: planData?.selectedViewData?.score ?? 0,
    quality_criteria: planData?.selectedViewData?.quality_criteria ?? [],
    isInReport: !!planData?.selectedViewData,
    selectedImageReport: planData?.selectedViewData?.imagePredictedPlane ?? defaultImageForTheme,
  };
};

// This function correctly passes the theme down to buildPlane
export const buildPlanes = (
  planeConfigs: PlaneConfig[],
  globalState: any,
  theme: 'light' | 'dark'
): Plane[] => {
  return planeConfigs.map(config => buildPlane(config, globalState, theme));
};